































































































import Vue from "vue";
import ChangePasswordModel from "../models/PasswordChangeModel";
import api from "../services/api";
import eventBus from "@/services/eventBus";
import auth from "@/services/auth";
import { Authentication } from "@/services/auth";
import { t } from "@/plugins/i18n";

interface Data {
  errorMessage: string | null;
  successMessage: string | null;
  changePasswordModel: ChangePasswordModel;
  auth: Authentication;
}

interface Method {
  postNewPassword(): void;
  isPasswordsOk(): boolean;
  pushToMainPage(): void;
}

export default Vue.extend<Data, Method, {}, {}>({
  data: () => ({
    changePasswordModel: new ChangePasswordModel(),
    errorMessage: null,
    successMessage: null,
    auth
  }),

  methods: {
    pushToMainPage() {
      this.$router.push("/");
    },

    async postNewPassword() {
      this.errorMessage = null;
      this.successMessage = null;
      if (!this.isPasswordsOk()) return;

      const result = await api.PostNewPassword(this.changePasswordModel);
      if (result.length > 0) {
        this.errorMessage = result;
      } else {
        this.errorMessage = null;
        this.changePasswordModel = new ChangePasswordModel();
        this.successMessage = t("JelszoSikeresenMegvaltoztatva");
        auth.passwordChangeRequired = false;
        setTimeout(() => {
          this.successMessage = null;
        }, 5000);
      }
    },

    isPasswordsOk() {
      if (
        this.changePasswordModel.newPassword !==
        this.changePasswordModel.newPasswordAgain
      ) {
        this.errorMessage =
          t("AzUjJelszoEsAzUj");
        return false;
      }
      if (
        this.changePasswordModel.currentPassword ===
        this.changePasswordModel.newPassword
      ) {
        this.errorMessage = t("AzUjJelszoMegegyezikAJelenlegi");
        return false;
      }
      if (
        this.changePasswordModel.currentPassword.length === 0 ||
        this.changePasswordModel.newPassword.length === 0 ||
        this.changePasswordModel.newPasswordAgain.length === 0
      ) {
        this.errorMessage = t("MindenMezoKitolteseSzukseges");
        return false;
      }

      return true;
    },
  },
});
